'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = require('./Table.component');

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Table2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-table/index.js
// module id = 2476
// module chunks = 0